import * as React from 'react';
import Upload from './Upload';
const Dragger = (props) => (<Upload {...props} type="drag" style={Object.assign({}, props.style, { height: props.height })}/>);
export default Dragger;
